import { render, staticRenderFns } from "./SectionPeriodeFiscale.vue?vue&type=template&id=678369d9&scoped=true&"
import script from "./SectionPeriodeFiscale.vue?vue&type=script&lang=js&"
export * from "./SectionPeriodeFiscale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678369d9",
  null
  
)

export default component.exports